import React, { useEffect, useMemo, useRef, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { adminAction } from '../../../redux/common/action'
import * as Yup from 'yup'

import Modal from 'react-bootstrap/Modal'
import { Link, useNavigate } from 'react-router-dom'
import { URL } from '../../../redux/common/url'
import moment from 'moment'
import Button from 'react-bootstrap/Button'

import { AsyncPaginate } from 'react-select-async-paginate'

// @ts-ignore
// import {CKEditor} from '@ckeditor/ckeditor5-react'
// @ts-ignore
// import Editor from 'ckeditor5-custom-build/build/ckeditor'

// image uploader
import ImageUploading from 'react-images-uploading'
import { toast } from 'react-toastify'
import axios from 'axios'
import { Loader } from '@googlemaps/js-api-loader'
import { DatePicker, Upload } from 'antd'
import { updateReport } from '../../../redux/Admin/action'

interface Option {
    value: string
    label: string
}
interface PaginatedResponse {
    results: Option[]
    has_more: boolean
}
interface Value {
    id: string
    name: string
}

function AllBookingList() {

    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(1);

    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [currentPage, setCurrentPage] = useState(1);
    const [circles, setCircles] = useState<Value[]>([]);
    const [name, setName] = useState<string>('');
    const [filterName, setFilterName] = useState<string>('');


    const fetchCircles = async () => {
        try {
            const response: any = await axios.get(`${URL.API_BASE_URL + URL.getAllCircles}`)
            if (response?.data?.data) {
                setCircles(response?.data?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchCircles();
    }, [])

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [pageNo, setpageNo] = useState<any>(1);

    const get_product_list: any = useSelector((state: any) =>
        state.admin.get_all_booking ? state.admin.get_all_booking : {}
    )
    const get_old_reports_list: any = useSelector((state: any) =>
        state.admin.old_reports_list ? state.admin.old_reports_list : {}
    )

    const ITEMS_PER_PAGE = 10

    const comments = get_product_list?.data ? get_product_list?.data : []
    const reportData = get_old_reports_list?.data ? get_old_reports_list?.data : []

    const handlePageClick = (event: any) => {
        const data = event?.selected + 1
        setpageNo(data)
    }

    useEffect(() => {
        const total = get_old_reports_list?.total || 0;
        setPageCount(Math.ceil(total / itemsPerPage));
    }, [get_old_reports_list?.total, itemsPerPage]);

    const [managerKey, setManagerKey] = useState<any>(0)
    const [managerKeyAen, setManagerKeyAen] = useState<any>(0)
    const [managerKeyJen, setManagerKeyJen] = useState<any>(0)

    const [seleceteMangerXen, setseleceteMangerXen] = useState<any>({})
    const [seleceteMangerAen, setseleceteMangerAen] = useState<any>({})
    const [seleceteMangerJen, setseleceteMangerJen] = useState<any>({})
    const [selectsource, setselectsource] = useState<any>({})
    const [criId, setcriId] = useState<any>('')


    useEffect(() => {
        const filterData: any = {
            circle_id: criId,
            xen_id: seleceteMangerXen?.id,
            aen_id: seleceteMangerAen?.id,
            jen_id: seleceteMangerJen?.id,
            date: date,
            name: filterName,
            page: pageNo
        }
        dispatch(adminAction.getOldReportsList({ ...filterData }));
    }, [criId, seleceteMangerXen?.id, seleceteMangerAen?.id, seleceteMangerJen?.id, filterName, pageNo, dispatch]);

    useEffect(() => {
        dispatch(adminAction.getgetAllCircles(''))
        return () => { }
    }, []);

    const loadOptionsgetManagerXen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v')
        const response = await fetch(
            URL.API_BASE_URL + `/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${criId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        )
        const responseJSON: PaginatedResponse = await response.json()
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id
            data.label = data?.name
            return data
        })
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        }
    };

    const loadOptionsgetManagerAen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v')
        const response = await fetch(
            URL.API_BASE_URL +
            `/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXen?.id}&circle_id=${criId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        )
        const responseJSON: PaginatedResponse = await response.json()
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id
            data.label = data?.name
            return data
        })
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        }
    };

    const loadOptionsgetManagerJen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v')
        const response = await fetch(
            URL.API_BASE_URL +
            `/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAen?.id}&circle_id=${criId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        )
        const responseJSON: PaginatedResponse = await response.json()
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id
            data.label = data?.name
            return data
        })
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        }
    };

    useEffect(() => {
        if (criId) {
            setManagerKey((prevKey: any) => prevKey + 1)
            setManagerKeyAen((prevKey: any) => prevKey + 1)
            setManagerKeyJen((prevKey: any) => prevKey + 1)
            setseleceteMangerXen({})
            setseleceteMangerAen({})
            setseleceteMangerJen({})
        }
    }, [criId])

    useEffect(() => {
        if (seleceteMangerXen?.id) {
            setManagerKeyAen((prevKey: any) => prevKey + 1)
            setManagerKeyJen((prevKey: any) => prevKey + 1)
            setseleceteMangerAen({})
            setseleceteMangerJen({})
        }
    }, [seleceteMangerXen])

    useEffect(() => {
        if (seleceteMangerAen?.id) {
            setManagerKeyJen((prevKey: any) => prevKey + 1)
            setseleceteMangerJen({})
        }
    }, [seleceteMangerAen])

    const [distance, setDistance] = useState<any>('');

    const [show, setShow] = useState(false)
    const [date, setDate] = useState<any>(null);
    const [modalDate, setModalDate] = useState<any>(null);
    const [showDelelt, setShowDelete] = useState(false)
    const [reportID, setReportID] = useState<any>('');
    const handleClose = () => setShow(false)

    const [roledata, setroledata] = useState<any>({
        role_name: '',
    })

    // NEW: Edit mode state
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingReport, setEditingReport] = useState<any>(null);

    // NEW: Modal loading state
    const [modalLoading, setModalLoading] = useState(false);

    const handleShow = () => {
        setShow(true)
        setIsEditMode(false);
        setEditingReport(null);
        setModalCriId('')
        setModalXen(null)
        setModalAen(null)
        setModalJen(null)
        setModalFileList([])
        setroledata({ role_name: '' })
        setModalDate(null)
        setManagerKey((prev: number) => prev + 1)
        setManagerKeyAen((prev: number) => prev + 1)
        setManagerKeyJen((prev: number) => prev + 1)
        setModalLoading(false)
    }

    const hendleChangerole = (e: any) => {
        const { name, value } = e.target
        setroledata({ ...roledata, [name]: value });
    }

    const [modalCriId, setModalCriId] = useState<string>('')
    const [modalXen, setModalXen] = useState<any>(null)
    const [modalAen, setModalAen] = useState<any>(null)
    const [modalJen, setModalJen] = useState<any>(null)
    const [modalFileList, setModalFileList] = useState<any[]>([])

    const modalLoadXen = async (search: string, loadedOptions: any, { page }: { page: number }) => {
        const token = localStorage.getItem('kt-auth-react-v')
        const parsed = token ? JSON.parse(token) : null
        const response = await fetch(
            `${URL.API_BASE_URL}/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${modalCriId}`,
            { headers: { Authorization: `Bearer ${parsed?.api_token}` } }
        )
        const json: PaginatedResponse = await response.json()
        const opts = json.results.map((d: any) => ({ value: d.id, label: d.name }))
        return { options: opts, hasMore: json.has_more, additional: { page: page + 1 } }
    }

    const modalLoadAen = async (search: string, loadedOptions: any, { page }: { page: number }) => {
        const token = localStorage.getItem('kt-auth-react-v')
        const parsed = token ? JSON.parse(token) : null
        const response = await fetch(
            `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${modalXen?.value}&circle_id=${modalCriId}`,
            { headers: { Authorization: `Bearer ${parsed?.api_token}` } }
        )
        const json: PaginatedResponse = await response.json()
        const opts = json.results.map((d: any) => ({ value: d.id, label: d.name }))
        return { options: opts, hasMore: json.has_more, additional: { page: page + 1 } }
    }

    const modalLoadJen = async (search: string, loadedOptions: any, { page }: { page: number }) => {
        const token = localStorage.getItem('kt-auth-react-v')
        const parsed = token ? JSON.parse(token) : null
        const response = await fetch(
            `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${modalAen?.value}&circle_id=${modalCriId}`,
            { headers: { Authorization: `Bearer ${parsed?.api_token}` } }
        )
        const json: PaginatedResponse = await response.json()
        const opts = json.results.map((d: any) => ({ value: d.id, label: d.name }))
        return { options: opts, hasMore: json.has_more, additional: { page: page + 1 } }
    }

    useEffect(() => {
        if (modalCriId) {
            setManagerKey((prev: number) => prev + 1)
            setManagerKeyAen((prev: number) => prev + 1)
            setManagerKeyJen((prev: number) => prev + 1)
            setModalXen(null)
            setModalAen(null)
            setModalJen(null)
        }
    }, [modalCriId])

    useEffect(() => {
        if (modalXen?.value) {
            setManagerKeyAen((prev: number) => prev + 1)
            setManagerKeyJen((prev: number) => prev + 1)
            setModalAen(null)
            setModalJen(null)
        }
    }, [modalXen])

    useEffect(() => {
        if (modalAen?.value) {
            setManagerKeyJen((prev: number) => prev + 1)
            setModalJen(null)
        }
    }, [modalAen])

    // NEW: Preload selected hierarchy on edit
    const preloadSelectedOptions = async (report: any) => {
        const token = localStorage.getItem('kt-auth-react-v');
        const parsed = token ? JSON.parse(token) : null;
        if (!parsed) return;

        const authHeader = {
            headers: { Authorization: `Bearer ${parsed.api_token}` }
        };

        try {
            setModalLoading(true);

            // 1. Load XENs and find selected
            const xenRes = await fetch(
                `${URL.API_BASE_URL}/api/admins/get_all_xen?search=&page=1&circle_id=${report.circle_id}`,
                authHeader
            );
            const xenData = await xenRes.json();
            const selectedXen = xenData.results?.find((x: any) => x.id == report.xen_id);
            if (selectedXen) {
                setModalXen({ value: selectedXen.id, label: selectedXen.name });

                // 2. Load AENs under selected XEN
                const aenRes = await fetch(
                    `${URL.API_BASE_URL}/api/admins/get_department_child?search=&page=1&id=${selectedXen.id}&circle_id=${report.circle_id}`,
                    authHeader
                );
                const aenData = await aenRes.json();
                const selectedAen = aenData.results?.find((a: any) => a.id == report.aen_id);
                if (selectedAen) {
                    setModalAen({ value: selectedAen.id, label: selectedAen.name });

                    // 3. Load JENs under selected AEN
                    const jenRes = await fetch(
                        `${URL.API_BASE_URL}/api/admins/get_department_child?search=&page=1&id=${selectedAen.id}&circle_id=${report.circle_id}`,
                        authHeader
                    );
                    const jenData = await jenRes.json();
                    const selectedJen = jenData.results?.find((j: any) => j.id == report.jen_id);
                    if (selectedJen) {
                        setModalJen({ value: selectedJen.id, label: selectedJen.name });
                    }
                }
            }
        } catch (err) {
            console.error("Failed to preload hierarchy:", err);
            toast.error("Failed to load user hierarchy");
        } finally {
            setModalLoading(false);
        }
    };

    // FIXED: Async edit handler with preloading
    const hendleEditReport = async (report: any) => {
        setIsEditMode(true);
        setEditingReport(report);
        setShow(true);

        setModalCriId(report.circle_id);
        setroledata({ role_name: report.name });
        setModalDate(report.date || '');
        setModalFileList([]);

        // Clear previous selections
        setModalXen(null);
        setModalAen(null);
        setModalJen(null);

        // Reset keys to force reload
        setManagerKey((prev: number) => prev + 1);
        setManagerKeyAen((prev: number) => prev + 1);
        setManagerKeyJen((prev: number) => prev + 1);

        // Preload selected values
        await preloadSelectedOptions(report);
    }

    const hendleModalShow = (e: any) => {
        setShowDelete(true)
        setReportID(e)
    }
    const handleCloseDelete = () => setShowDelete(false)

    const hendleDelete = () => {
        setShowDelete(false)
        dispatch(adminAction.deleteReport(reportID))
        return () => { }
    }

    const hendleToAcctive = (e: any, active: any) => {
        const data = new FormData()
        data.append('id', e)
        data.append('active', active)
        dispatch(adminAction.activeInactiveOldReports(data))
        // hendlerolewise('');
    }

    const hendleSubmitCreate = () => {
        try {
            if (!roledata?.role_name) return toast.error('Please enter name');
            if (!modalCriId) return toast.error('Please select circle');
            if (!modalXen?.value) return toast.error('Please select XEN');
            if (!modalAen?.value) return toast.error('Please select AEN');
            if (!modalJen?.value) return toast.error('Please select JEN');
            if (!modalDate) return toast.error('Please select date');

            const file = modalFileList[0];

            if (!isEditMode && !file) {
                return toast.error('Please upload file');
            }

            if (file) {
                const allowedTypes = [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ];
                if (!allowedTypes.includes(file.type)) {
                    return toast.error('Only PDF, XLS, XLSX files are allowed');
                }
            }

            const data = new FormData();
            data.append('name', roledata.role_name);
            data.append('xen_id', modalXen.value);
            data.append('aen_id', modalAen.value);
            data.append('jen_id', modalJen.value);
            data.append('circle_id', modalCriId);
            data.append('date', modalDate);
            if (file) data.append('file', file);

            if (isEditMode && editingReport) {
                data.append('id', editingReport.id);
                dispatch(updateReport(Object.fromEntries(data)));
            } else {
                dispatch(adminAction.createOldReports(data) as any);
            }

            handleClose();
            setroledata({ role_name: '' });
            setModalDate(null);
            setModalFileList([]);
            setModalCriId('');
            setModalXen(null);
            setModalAen(null);
            setModalJen(null);
            setIsEditMode(false);
            setEditingReport(null);

        } catch (error) {
            console.error("Error in hendleSubmitCreate: ", error);
            toast.error("Failed to submit form");
        }
    };

    // NEW: View file in new tab
    const handleViewFile = (fileUrl: string) => {
        if (fileUrl) {
            window.open(URL.API_BASE_URL + fileUrl, '_blank');
        }
    };

    return (
        <div>

            <div className='d-flex flex-column flex-column-fluid'>
                <div id='kt_app_toolbar' className='app-toolbar py-3 py-lg-6'>
                    <div id='kt_app_toolbar_container' className='d-flex flex-stack container-xxl'>
                        <div className='d-flex flex-column flex-wrap me-3 page-title'>
                            <h1 className='my-0 fw-bold text-dark page-heading fs-3'>
                                Current Job
                            </h1>
                            <ul className='my-0 breadcrumb-separatorless pt-1 fw-semibold breadcrumb fs-7'>
                                <li className='breadcrumb-item text-muted'>
                                    <Link to={'/'} className='text-hover-primary text-muted'>
                                        Home
                                    </Link>
                                </li>
                                <li className='breadcrumb-item'>
                                    <span className='bg-gray-400 w-5px h-2px bullet'></span>
                                </li>
                                <li className='breadcrumb-item text-muted'> Current Job</li>
                            </ul>
                        </div>
                        <div className='d-flex align-items-center gap-2 gap-lg-3'>
                            <div className='m-0'>
                            </div>
                        </div>
                    </div>
                </div>

                <div id='kt_app_content' className='flex-column-fluid app-content'>
                    <div id='' className=' '>
                        <div className='card card-flush'>
                            <div className='row'>
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span>Search</span>
                                        </label>
                                        <input
                                            type='search'
                                            placeholder='Search wise Name'
                                            className='form-control'
                                            onChange={(e: any) => setName(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span className=''>Circle</span>
                                        </label>
                                        <select
                                            className='bg-transparent form-control'
                                            aria-label='Select example'
                                            name='circle_id'
                                            onChange={(e: any) => {
                                                setcriId(e?.target?.value)
                                                setseleceteMangerXen({})
                                                setseleceteMangerAen({})
                                                setseleceteMangerJen({})
                                                setpageNo(1)
                                            }}
                                        >
                                            <option value={''}>Select Circle</option>
                                            {circles?.map((data, i) => {
                                                return (
                                                    <option value={data?.id} key={i}>
                                                        {data?.name}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>

                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span className=''>Select Xen</span>
                                        </label>
                                        <AsyncPaginate<any, any, any>
                                            key={managerKey}
                                            value={seleceteMangerXen}
                                            loadOptions={loadOptionsgetManagerXen}
                                            onChange={(e: any) => {
                                                setseleceteMangerXen(e)
                                                setseleceteMangerAen({})
                                                setseleceteMangerJen({})
                                                setpageNo(1)
                                            }}
                                            additional={{
                                                page: 1,
                                            }}
                                            className='bg-transparent form-control'
                                        />
                                    </div>
                                </div>

                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span className=''>Select Aen</span>
                                        </label>
                                        <AsyncPaginate<any, any, any>
                                            key={managerKeyAen}
                                            value={seleceteMangerAen}
                                            loadOptions={loadOptionsgetManagerAen}
                                            onChange={(e: any) => {
                                                setseleceteMangerAen(e)
                                                setseleceteMangerJen({})
                                                setpageNo(1)
                                            }}
                                            additional={{
                                                page: 1,
                                            }}
                                            className='bg-transparent form-control'
                                        />
                                    </div>
                                </div>

                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span className=''>Select Jen</span>
                                        </label>
                                        <AsyncPaginate<any, any, any>
                                            key={managerKeyJen}
                                            value={seleceteMangerJen}
                                            loadOptions={loadOptionsgetManagerJen}
                                            onChange={(e: any) => {
                                                setseleceteMangerJen(e)
                                                setpageNo(1)
                                            }}
                                            additional={{
                                                page: 1,
                                            }}
                                            className='bg-transparent form-control'
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <div className='row'>
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span className=''>Name</span>
                                        </label>
                                        <input
                                            placeholder='Enter name'
                                            name='name'
                                            value={filterName || ''}
                                            className='form-control'
                                            onChange={(e: any) => {
                                                setFilterName(e?.target?.value)
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span className=''>Date</span>
                                        </label>
                                        <div>
                                            <input
                                                placeholder='Select a date'
                                                name='name'
                                                type='date'
                                                className='form-control'
                                                value={date || ''}
                                                onChange={(e: any) => {
                                                    setDate(e?.target?.value)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className='mt-6 card-header'>
                                <div className='card-title'>
                                    <div className='position-relative d-flex align-items-center my-1 me-5'></div>
                                    <div className='position-relative d-flex align-items-center my-1 me-5'></div>
                                </div>

                                <div
                                    className='card-toolbar'
                                    style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                                >

                                    <button type='button' className='btn btn-light-primary' onClick={handleShow}>
                                        <span className='svg-icon svg-icon-3'>
                                            <svg
                                                width='24'
                                                height='24'
                                                viewBox='0 0 24 24'
                                                fill='none'
                                                xmlns='http://www.w3.org/2000/svg'
                                            >
                                                <rect
                                                    opacity='0.3'
                                                    x='2'
                                                    y='2'
                                                    width='20'
                                                    height='20'
                                                    rx='5'
                                                    fill='currentColor'
                                                />
                                                <rect
                                                    x='10.8891'
                                                    y='17.8033'
                                                    width='12'
                                                    height='2'
                                                    rx='1'
                                                    transform='rotate(-90 10.8891 17.8033)'
                                                    fill='currentColor'
                                                />
                                                <rect
                                                    x='6.01041'
                                                    y='10.9247'
                                                    width='12'
                                                    height='2'
                                                    rx='1'
                                                    fill='currentColor'
                                                />
                                            </svg>
                                        </span>
                                        Add Vendor
                                    </button>
                                </div>
                            </div>

                            <div className='pt-0 card-body' style={{ overflow: 'auto' }}>
                                <table
                                    className='table table-row-dashed mb-0 align-middle fs-6 gy-5'
                                    id='kt_permissions_table'
                                >
                                    <thead className='table-light'>
                                        <tr>
                                            <th>S.NO.</th>
                                            <th>Name</th>
                                            <th>Date</th>
                                            <th>Circle</th>
                                            <th>XEN</th>
                                            <th>AEN</th>
                                            <th>JEN</th>
                                            <th>File</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ maxHeight: '60vh', overflow: 'auto' }}>
                                        {reportData.length > 0 &&
                                            reportData.map((item: any, index: any) => (
                                                <tr key={index}>
                                                    <td> {(pageNo - 1) * 10 + index + 1} </td>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.date || '-'}</td>
                                                    <td>{item?.circle?.name || '-'}</td>
                                                    <td>{item?.xen?.name || '-'}</td>
                                                    <td>{item?.aen?.name || '-'}</td>
                                                    <td>{item?.jen?.name || '-'}</td>
                                                    <td> <button
                                                        data-id='2209'
                                                        onClick={() => {
                                                            hendleToAcctive(item?.id, item?.active ? 0 : 1)
                                                        }}
                                                        className={
                                                            item?.active
                                                                ? 'btn btn-sm btn-success ms-3'
                                                                : 'btn btn-sm btn-danger ms-3'
                                                        }
                                                    >
                                                        {item?.active ? 'Active' : 'Inactive'}
                                                    </button></td>
                                                    <td>
                                                        {item?.file ? (
                                                            <button
                                                                onClick={() => handleViewFile(item.file)}
                                                                className="btn btn-sm btn-success"
                                                            >
                                                                View
                                                            </button>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </td>
                                                    <td>
                                                        <button
                                                            // onClick={() => hendleEditReport(item)}
                                                            className='ms-3 btn btn-sm btn-info'
                                                        >
                                                            <i className='fas fa-edit'></i>
                                                        </button>
                                                        <button
                                                            onClick={() => hendleModalShow(item?.id)}
                                                            className='ms-3 btn btn-sm btn-danger'
                                                        >
                                                            <i className='fa-trash-alt fas'></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                    {reportData.length === 0 && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '400px',
                                            }}
                                        >
                                            <h3>Record Not found</h3>
                                        </div>
                                    )}
                                </table>

                                <ReactPaginate
                                    breakLabel='...'
                                    nextLabel='next'
                                    className='dataTables_paginate paging_simple_numbers category'
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={2}
                                    pageCount={pageCount}
                                    previousLabel='previous'
                                    forcePage={pageNo - 1}
                                />
                            </div>

                            <Modal show={show} dialogClassName='modal-90w' onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>{isEditMode ? 'Edit Report' : 'Add Vendor'}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {modalLoading && (
                                        <div className="text-center p-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-2">Loading user hierarchy...</p>
                                        </div>
                                    )}

                                    <div className='row'>
                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'> Circle </span>
                                            </label>
                                            <select
                                                className='bg-transparent form-control'
                                                aria-label='Select example'
                                                name='circle_id'
                                                value={modalCriId}
                                                onChange={(e: any) => {
                                                    setModalCriId(e.target.value)
                                                    setModalXen(null)
                                                    setModalAen(null)
                                                    setModalJen(null)
                                                }}
                                                disabled={modalLoading}
                                            >
                                                <option value={''}>Select Circle</option>
                                                {circles?.map((data, i) => (
                                                    <option value={data?.id} key={i}>{data?.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'>Select Xen</span>
                                            </label>
                                            <AsyncPaginate<any, any, any>
                                                key={managerKey}
                                                value={modalXen}
                                                loadOptions={modalLoadXen}
                                                onChange={(e: any) => {
                                                    setModalXen(e)
                                                    setModalAen(null)
                                                    setModalJen(null)
                                                }}
                                                additional={{ page: 1 }}
                                                isDisabled={modalLoading}
                                            />
                                        </div>

                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'>Select Aen</span>
                                            </label>
                                            <AsyncPaginate<any, any, any>
                                                key={managerKeyAen}
                                                value={modalAen}
                                                loadOptions={modalLoadAen}
                                                onChange={(e: any) => {
                                                    setModalAen(e)
                                                    setModalJen(null)
                                                }}
                                                additional={{ page: 1 }}
                                                isDisabled={modalLoading}
                                            />
                                        </div>

                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'>Select Jen</span>
                                            </label>
                                            <AsyncPaginate<any, any, any>
                                                key={managerKeyJen}
                                                value={modalJen}
                                                loadOptions={modalLoadJen}
                                                onChange={setModalJen}
                                                additional={{ page: 1 }}
                                                isDisabled={modalLoading}
                                            />
                                        </div>

                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'> Name</span>
                                            </label>
                                            <input
                                                placeholder='Enter a name'
                                                name='role_name'
                                                className='form-control'
                                                value={roledata?.role_name || ''}
                                                onChange={hendleChangerole}
                                                disabled={modalLoading}
                                            />
                                        </div>
                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'> Date</span>
                                            </label>
                                            <input
                                                placeholder='Select a date'
                                                name='name'
                                                type='date'
                                                className='form-control'
                                                value={modalDate || ''}
                                                onChange={(e: any) => {
                                                    setModalDate(e?.target?.value)
                                                }}
                                                disabled={modalLoading}
                                            />
                                        </div>

                                        <div className='mb-7 fv-row col-3'>
                                            <label className='form-label mb-2 fw-semibold fs-6'>
                                                <span className='required'>Upload File {isEditMode && '(Optional)'}</span>
                                            </label>
                                            {isEditMode && editingReport?.file && (
                                                <div className="text-muted mb-2">
                                                    Current: <strong>{editingReport.file.split('/').pop()}</strong>
                                                </div>
                                            )}
                                            <Upload
                                                fileList={modalFileList}
                                                beforeUpload={(file) => {
                                                    setModalFileList([file])
                                                    return false
                                                }}
                                                className='form-control'
                                                onRemove={() => setModalFileList([])}
                                                accept=".pdf,.xls,.xlsx,.csv"
                                                disabled={modalLoading}
                                            >
                                                <button className="ant-btn ant-btn-default" type="button" disabled={modalLoading}>
                                                    {modalFileList.length > 0 ? 'Change File' : 'Select File'}
                                                </button>
                                            </Upload>
                                        </div>
                                    </div>

                                    <div className='pt-15 text-center'>
                                        <button
                                            type='reset'
                                            className='me-3 btn btn-light'
                                            onClick={handleClose}
                                            disabled={modalLoading}
                                        >
                                            Discard
                                        </button>
                                        <button
                                            type='submit'
                                            className='btn btn-primary'
                                            onClick={hendleSubmitCreate}
                                            disabled={modalLoading}
                                        >
                                            {!loading && <span className='indicator-label'>{isEditMode ? 'Update' : 'Submit'}</span>}
                                            {loading && (
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    Please wait...
                                                    <span className='ms-2 spinner-border spinner-border-sm align-middle'></span>
                                                </span>
                                            )}
                                        </button>
                                    </div>
                                </Modal.Body>
                            </Modal>
                            {/* delete modal  */}
                            <Modal show={showDelelt} onHide={handleCloseDelete}>
                                <Modal.Header closeButton>
                                    <Modal.Title> Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to delete this report?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant='secondary'
                                        onClick={handleCloseDelete}
                                    >
                                        No
                                    </Button>
                                    <Button variant='primary'
                                        onClick={hendleDelete}
                                    >
                                        Yes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllBookingList